<script>
import { AGENT_STEP_PILL_VARIANTS } from './constants';

export default {
  name: 'AgentStepPill',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'neutral',
      validator: (value) => Object.keys(AGENT_STEP_PILL_VARIANTS).includes(value),
    },
    ariaLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    pillStyle() {
      return {
        backgroundColor: AGENT_STEP_PILL_VARIANTS[this.variant],
      };
    },
  },
};
</script>
<template>
  <span
    class="gl-block gl-h-2 gl-w-5 gl-rounded-sm"
    :style="pillStyle"
    role="status"
    :aria-label="ariaLabel"
  ></span>
</template>
